export default "__VITE_PUBLIC_ASSET__87912714__"